"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertWarning = exports.assertUsage = void 0;
var packageName_1 = require("../../utils/packageName");
function assertUsage(bool, errorMsg) {
    if (bool) {
        return;
    }
    throw new Error("[" + packageName_1.packageName + "] " + errorMsg);
}
exports.assertUsage = assertUsage;
function assertWarning(bool, warningMsg) {
    if (bool) {
        return;
    }
    setTimeout(function () {
        throw new Error("[" + packageName_1.packageName + "] " + warningMsg);
    }, 0);
}
exports.assertWarning = assertWarning;
//# sourceMappingURL=assertUsage.js.map